import React, { useState, useEffect } from "react";
import Classes from "./Meetings.module.css";
import RecordTable from "../Dashboard/Comp/RecordTable/RecordTable";
import { useSelector } from "react-redux";
import backend from "../../../../../api";

export default function Meetings() {
  const { user } = useSelector((state) => state.auth);
  const userId = user?._id
  const mentorId = user?._id;
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  async function GetBookings() {
    try {
      const response = await backend.get(`/bookings/mentor?mentorId=${mentorId}`);
      console.log(response)
      setBookings(response.data);
      setLoading(false);
    } catch (err) {
      console.error("Error fetching bookings:", err);
      setError(err.response?.data?.error || "Failed to load bookings");
      setLoading(false);
    }
  }

  useEffect(() => {
    if (userId) {
      GetBookings();
    }
  }, [userId]);

  return (
    <div className={Classes.hero}>
      <div className={Classes.header}>
        <div>
          <h3 className={Classes.title3}>Meetings</h3>
          <h5 className={Classes.text}>Review your upcoming and past meetings.</h5>
        </div>
        <div>
          <div className={Classes.searcCon}>
            <img src="/assets/images/search.png" alt="icon" />
            <input type="text" placeholder="Search..." />
          </div>
        </div>
      </div>

        <RecordTable bookings={bookings} loading={loading} />
    </div>
  );
}